import { create } from 'zustand';

interface DoBoxRulesManageState {
  isOpen: boolean;
}

interface DoBoxRulesManageActions {
  open: () => void;
  close: () => void;
}

type DoBoxRulesManageStore = DoBoxRulesManageState & DoBoxRulesManageActions;

export const useDoBoxRulesManageStore = create<DoBoxRulesManageStore>(
  (set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }),
);
